export const LOCAL_STORAGE_KEY = 'AUTOCOMPLETE_RECENT_SEARCHES';
export const LOCAL_STORAGE_KEY_TEST =
  '__AUTOCOMPLETE_RECENT_SEARCHES_PLUGIN_TEST_KEY__';
